import React, { useRef, useState } from "react";

import classNames from "classnames";

import { type MultiPackProduct } from "@jti/fe-common";
import { useOutsideClick } from "@jti/ui/hooks/useOutsideClick";

import { ProductMultiPacksHeader } from "./ProductMultipacksHeader";
import { ProductMultiPacksItem } from "./ProductMultipacksItem";

import "./ProductMultipacks.scss";

type ProductMultiPacksType = {
  currentProduct: MultiPackProduct;
  multiPackProducts: Array<MultiPackProduct>;
  isMultiPackEnabled: boolean;
};

export const ProductMultipacks = ({ currentProduct, multiPackProducts, isMultiPackEnabled }: ProductMultiPacksType) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  useOutsideClick(dropdownRef, () => {
    setIsOpen(false);
  });

  if (!isMultiPackEnabled) {
    return <React.Fragment />;
  }

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const className = classNames("product-multipacks", {
    "product-multipacks--open": isOpen,
  });

  return (
    <div className={"product-multipacks__wrapper"}>
      <div ref={dropdownRef} data-testid="product-multipacks" className={className} onClick={toggleDropdown}>
        <ProductMultiPacksHeader item={currentProduct} />
        <ul className={"product-multipacks__list"}>
          {multiPackProducts?.map((product: MultiPackProduct) => (
            <ProductMultiPacksItem key={product.sku} item={product} />
          ))}
        </ul>
      </div>
    </div>
  );
};
